module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"caris-select":{"loading":"Indlæs"}},"de":{"caris-select":{"loading":"Laden"}},"fr":{"caris-select":{"loading":"Charger"}},"nl":{"caris-select":{"loading":"Laden"}}}')
  delete Component.options._Ctor
}
